export class Assignment
{
	id: number;
	parent_id: number;
	organisation_id: number;
	assignment_type: string;
	assignment_number: number;
	date: string;
	description: string;
	status: string;
}



// WEBPACK FOOTER //
// ./src/app/models/assignment.ts